export default __webpack_public_path__ + "static/media/mobile.b90c2c51.png";